import { NavigateFunction } from 'react-router';
import moment from 'moment-jalaali';

const numberRegex = /^[0-9\b]+$|^$/;

export const changeNumber = (e) => {
  let text = e;
  if (numberRegex.test(e)) {
    if (
      text.split('')[0] === '+' &&
      text.split('')[1] === '9' &&
      text.split('')[2] === '8'
    ) {
      text = '0' + text.substr(3, 10);
      return text;
    } else if (text.split('')[0] !== '0' && text.length === 10) {
      text = '0' + text;
      return text;
    } else if (text.length < 12) {
      return text;
    }
  }
  return '';
};

// convert Gregorian date to jalaali
export const convertToJalaliDate = (date: string | Date): string =>
  (date && moment(date).locale('en').format('jYYYY/jMM/jDD').trim()) || null;

export const convertToPersian = (numberString) => {
  const number = String(numberString);
  const persianDigits = {
    '0': '۰',
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹'
  };

  let persianString = '';
  for (let i = 0; i < number.length; i++) {
    const digit = number[i];
    // eslint-disable-next-line no-prototype-builtins
    if (persianDigits.hasOwnProperty(digit)) {
      persianString += persianDigits[digit];
    } else {
      persianString += digit;
    }
  }

  return persianString;
};

/**
 *  23456.789 => 23,466
 * @param key: number or string
 * @param isRound: boolean
 * @returns {string}
 */
export const fixLocaleString = (
  key,
  isPersian = true,
  isRound = true,
  toFixNum = 0
): string => {
  if (key === null || key === undefined) return '';
  const number = Number(key);
  return !number
    ? key
    : (number < 10 && number > -10) || !isRound
    ? !toFixNum
      ? number.toLocaleString()
      : number.toFixed(toFixNum)
    : isPersian
    ? convertToPersian(Math.round(key).toLocaleString())
    : Math.round(key).toLocaleString();
};

export const toPascalCase = (str: string): string =>
  (str.match(/[a-zA-Z0-9]+/g) || [])
    .map((w) => `${w.charAt(0).toUpperCase()}${w.slice(1)}`)
    .join('');

/**
 * result must not be null or undefined
 * if withoutZero=true => 0 is not valid too
 * @param {number | any} number
 * @returns {boolean}
 */
export const isValid = (value, withoutZero = false): boolean =>
  !(value === null || value === undefined || (withoutZero && value === 0));

export const removeDuplicatesFromArray = (arr: any[]): any[] => {
  return arr.filter((obj, index, self) => {
    return (
      index === self.findIndex((o) => JSON.stringify(o) === JSON.stringify(obj))
    );
  });
};

export const persianSortByKey = (array: any[], key?: string) => {
  const collator = new Intl.Collator('fa', { sensitivity: 'base' });
  return key
    ? array.sort((a, b) => collator.compare(a[key], b[key]))
    : array.sort((a, b) => collator.compare(a, b));
};

export const fixCreditCode = (code: string) => {
  const newCode = [];
  for (let i = 0; i < code.length; i++) {
    if (i % 3 === 0 && i !== 0) {
      newCode.push(' ');
      newCode.push(code.charAt(i));
    } else newCode.push(code.charAt(i));
  }
  return newCode.join('');
};

export const logoutAction = (navigate: NavigateFunction, smsUrl: string) => {
  localStorage.setItem('access_token', '');
  localStorage.setItem('refresh_token', '');
  navigate(smsUrl);
};

export function getQueryParams(string: string): { [key: string]: string } {
  if (!string.matchAll) return {};
  const regexp = /(\?|&)([^=]+)=([^&]+)/g;
  const arr = [...(string.matchAll(regexp) || [])];
  return arr.reduce((obj, item) => {
    // eslint-disable-next-line
    obj[item[2]] = item[3];
    return obj;
  }, {});
}

export const isEmail = (text: string) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(text);
};
